import { ISendContractViaEmailDTO } from 'modules/customer/domain/dtos';
import { IContractEmailsRepository } from 'modules/customer/domain/repositories';

export class SendContractViaEmailUseCase {
  constructor(private contractEmailsRepository: IContractEmailsRepository) {}

  public async execute({ contractId, customerId }: ISendContractViaEmailDTO) {
    return this.contractEmailsRepository.create({
      contractId,
      customerId,
    });
  }
}
